import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import getHelpLink from '../../../../helpers/getHelpLink';
import COPY from './getFooterCopy';

const getPrivateLabelAuthFooter = lang => {
  return [
    {
      title: t(COPY.ABOUT_PRIVATE_LABEL, { label: 'Momentive' }),
      url: createURL('https://www.momentive.ai/about/', {
        ut_source: 'footer',
      }),
    },
    {
      title: t(COPY.CAREERS),
      url: createURL('https://www.surveymonkey.com/careers/', {
        ut_source: 'footer',
      }),
    },
    {
      title: t(COPY.DEVELOPERS),
      url: createURL(`https://developer.surveymonkey.com/`, {
        ut_source: 'footer',
      }),
    },
    {
      title: t(COPY.PRIVACY_NOTICE),
      url: createURL('https://www.surveymonkey.com/mp/legal/privacy/', {
        ut_source: 'footer',
      }),
    },
    {
      title: t(COPY.CALIFORNIA_PRIVACY_NOTICE),
      url: createURL(
        'https://www.surveymonkey.com/mp/legal/region-specific-privacy-statement/',
        {
          ut_source: 'footer',
        }
      ),
    },
    lang === 'de' && {
      title: 'Impressum',
      url: createURL('https://www.surveymonkey.com/mp/impressum/', {
        ut_source: 'footer',
      }),
    },
    {
      title: t(COPY.EMAIL_OPT_IN),
      url: createURL('https://www.surveymonkey.com/user/email-opt-in/', {
        ut_source: 'footer',
      }),
    },
    {
      title: t(COPY.HELP),
      url: getHelpLink(lang, {
        params: { ut_source: 'footer' },
      }),
    },
    {
      title: t(COPY.COOKIES_NOTICE),
      url: createURL('https://www.surveymonkey.com/mp/legal/cookies/', {
        ut_source: 'footer',
      }),
    },
  ].filter(Boolean);
};

const getAuthFooterLinks = (domain, lang, isPrivateLabel = false) => {
  if (isPrivateLabel) {
    return getPrivateLabelAuthFooter(lang);
  }
  const items = [
    isPrivateLabel
      ? {
          title: t(COPY.ABOUT_PRIVATE_LABEL, { label: 'Momentive' }),
          url: createURL('/about/', { ut_source: 'footer' }),
        }
      : {
          title: t(COPY.ABOUT_SURVEYMONKEY),
          url: createURL('/mp/aboutus/', { ut_source: 'footer' }),
        },
    {
      title: t(COPY.CAREERS),
      url: createURL('/careers/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.DEVELOPERS),
      url: createURL(`https://developer.${domain}.com/`, {
        ut_source: 'footer',
      }),
    },
    {
      title: t(COPY.PRIVACY_NOTICE),
      url: createURL('/mp/legal/privacy/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.CALIFORNIA_PRIVACY_NOTICE),
      url: createURL('/mp/legal/region-specific-privacy-statement/', {
        ut_source: 'footer',
      }),
    },
    lang === 'de' && {
      title: 'Impressum',
      url: createURL('/mp/impressum/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.EMAIL_OPT_IN),
      url: createURL('/user/email-opt-in/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.HELP),
      url: getHelpLink(lang, {
        params: { ut_source: 'footer' },
      }),
    },
    {
      title: t(COPY.COOKIES_NOTICE),
      url: createURL('/mp/legal/cookies/', { ut_source: 'footer' }),
    },
  ];
  return items.filter(Boolean);
};

export default getAuthFooterLinks;
